import { Utils } from '../../Core';
import { countryApi as API } from '../../Apis';
import { CountriesTypes } from '../../Types';
import { mocksService } from './Countries.mock';
import dataFields from '../../Types/Countries.json';

const formatListCountries = (
  data: CountriesTypes.CountryData[],
  brFirst = false,
  ddiOrder = false,
) => {
  const listCountries = data;

  const compareDDI = (aDDI: number, bDDI: number) => {
    if (aDDI > bDDI) {
      return 1;
    }
    if (aDDI < bDDI) {
      return -1;
    }
    return 0;
  };

  if (ddiOrder) {
    // ordenação por DDI
    listCountries.sort(
      (a: CountriesTypes.CountryData, b: CountriesTypes.CountryData) => {
        const aDDI = Number(a.ddi);
        const bDDI = Number(b.ddi);
        const rDDI = compareDDI(aDDI, bDDI);
        return rDDI === 0 ? a.country.localeCompare(b.country) : rDDI;
      },
    );
  } else {
    // ordenação pelo nome do país
    listCountries.sort(
      (a: CountriesTypes.CountryData, b: CountriesTypes.CountryData) => {
        return a.country.localeCompare(b.country);
      },
    );
  }

  if (brFirst) {
    const brPosition = listCountries
      .map((c: CountriesTypes.CountryData) => c.iso2)
      .indexOf('BR');
    if (brPosition >= 0) {
      listCountries.unshift(listCountries[brPosition]);
      listCountries.splice(brPosition + 1, 1);
    }
  }

  return listCountries;
};
/* eslint-disable @typescript-eslint/no-explicit-any */
const handleSucessFinalResponseFunction = (data: any, inputParameters: any) => {
  if (data?.constructor === Array) {
    data = formatListCountries(
      data,
      inputParameters?.brFirst,
      inputParameters?.ddiOrder,
    );
  }

  return data;
};
/* eslint-disable @typescript-eslint/no-explicit-any */
const prepareCall = (stateRequestParameters: any) => {
  return API.call.get({
    ...stateRequestParameters?.filter,
  });
};
export const { machine, Docs } = Utils.genericMachine({
  mocksService,
  dataFields,
  invokeApiFunction: prepareCall,
  definitionsAPI: API.definitions,
  handleResponse: {
    handleSucessFinalResponseFunction,
  },
});
